export const actions = {
    SET_EMBEDS: 'SET_EMBEDS',
};

export const setEmbeds = payload => ({
    type: actions.SET_EMBEDS,
    payload,
});
